import { CognitoAuth } from "amazon-cognito-auth-js";
import { jwtDecode } from "jwt-decode";
import { setUserDetails } from "./account";
import { app_client_id, app_web_domain_name } from "../config";
import { hasPrivilege } from "../Components/Utils/utils";

const authData = {
  ClientId: app_client_id,
  // ClientId: '1gchgfv8vghi1iancuk8ev5b2m',
  AppWebDomain: app_web_domain_name,
  // AppWebDomain: 'eu-nonprod-appications.auth.eu-west-1.amazoncognito.com',
  TokenScopesArray: [],
  IdentityProvider: "COGNITO",
  RedirectUriSignIn: window.location.origin + "/callback",
  RedirectUriSignOut: window.location.origin,
};

const auth = new CognitoAuth(authData);

export const login = () => {
  return (dispatch) => {
    loginDispatch(dispatch);
    auth.getSession();
  };
};

const loginDispatch = (dispatch) => {
  auth.userhandler = {
    onSuccess: function (result) {
      var token = result.getIdToken().getJwtToken();
      var decoded_token = jwtDecode(token);
      let pools = decoded_token["custom:userpoolRole"]
        ? decoded_token["custom:userpoolRole"].split(",")
        : [];
      let roles = decoded_token["custom:accessrole"]
        ? decoded_token["custom:accessrole"].split(",")
        : [];
      let isAdmin = roles && hasPrivilege(roles, ["COGNITO_SUPER_ADMIN"]);
      dispatch({ type: "LOGIN_SUCCESS", data: { token: token } });
      dispatch({ type: "IS_ADMIN", data: { superAdmin: isAdmin } });
      dispatch(setUserDetails(decoded_token, pools, roles));
    },
    onFailure: function (err) {
      console.log("ERROR::", err);
    },
  };
};

export const authReceived = (href) => {
  return (dispatch) => {
    loginDispatch(dispatch);
    auth.parseCognitoWebResponse(href);
  };
};

export const logout = () => {
  auth.signOut();
  return (dispatch) => dispatch({ type: "USER_LOGOUT" });
};
